import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { Root as Root2 } from '../../../../../_externals/.pnpm/@radix-ui_react-accordion@1.2.0_@types_react@18.3.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@radix-ui/react-accordion/dist/index.js';

var Root = styled(Root2)({
    width: "100%",
    padding: "0 ".concat(tokens.spacing[6], " 0 ").concat(tokens.spacing[4]),
});

export { Root };
//# sourceMappingURL=Root.styles.js.map
